import { render, staticRenderFns } from "./badge-keyword.vue?vue&type=template&id=56abaa06&scoped=true"
import script from "./badge-keyword.vue?vue&type=script&lang=js"
export * from "./badge-keyword.vue?vue&type=script&lang=js"
import style0 from "./badge-keyword.vue?vue&type=style&index=0&id=56abaa06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56abaa06",
  null
  
)

export default component.exports